import axios from "axios";
import urls from "../../urls";
import {
  COUNTRY_CODE_BELGIUM,
  COUNTRY_CODE_FRANCE,
  COUNTRY_CODE_GERMANY,
  COUNTRY_CODE_NETHERLANDS,
} from "../../constants/OrderConstant";
import {
  BANKACCOUNT_TYPE_BE,
  BANKACCOUNT_TYPE_DE,
  BANKACCOUNT_TYPE_FR,
  BANKACCOUNT_TYPE_NL,
} from "../../constants/PaymentConstants";

const getVatCode = (country) => {
  switch (country) {
    case COUNTRY_CODE_BELGIUM:
      return "21";
    default:
      return null;
  }
};

// Map a country code to an Exact bank account type using a switch
const getBankAccountTypeByCountry = (country) => {
  switch (country) {
    case COUNTRY_CODE_NETHERLANDS:
      return BANKACCOUNT_TYPE_NL;
    case COUNTRY_CODE_BELGIUM:
      return BANKACCOUNT_TYPE_BE;
    case COUNTRY_CODE_GERMANY:
      return BANKACCOUNT_TYPE_DE;
    case COUNTRY_CODE_FRANCE:
      return BANKACCOUNT_TYPE_FR;
    default:
      return BANKACCOUNT_TYPE_NL;
  }
};

export const createExactAccount = (values, token) => {
  return new Promise((resolve, reject) => {
    const extraVelden = [];
    // if (values.directDebit && values.accountHolder)
    //   extraVelden.push({ naam: "Rekeninghouder", waarde: values.accountHolder });
    // if (values.directDebit && values.accountHolderLocation)
    //   extraVelden.push({ naam: "Locatie rekeninghouder", waarde: values.accountHolderLocation });
    const addressLine =
      values.street + " " + values.houseNumber + (values.houseNumberAddition ? " " + values.houseNumberAddition : "");

    const object = {
      id: values.customerId,
      AccountName: values.customerName,
      EmailAddress: values.customerEmail,
      ContactFirstName: values.contact?.userFirstName,
      ContactLastName: values.contact?.userLastName,
      DeliveryAddressline1: addressLine,
      DeliveryPostCode: values.zipCode,
      DeliveryCity: values.city,
      DeliveryCountry: values.country,
      ChamberofCommerceNumber: values.kvkNumber,
      PhoneNumber: values.customerPhone,
      TextFreeField2: values.customerDeliveryDays,
      // incassoSoort: values.paymentMethod === "directDebit" ? "Core" : "Geen", // TODO
      // extraVeldenKlant: extraVelden,
    };

    // Only add VatCode if taxNumber is filled in
    if (!!values.taxNumber) {
      object.VatNumber = values.taxNumber;
      object.VatCode = getVatCode(values.country);
    }
    // IBAN
    if (values.paymentCardNumber) {
      object.IBAN = values.paymentCardNumber;
      object.BankAccount = values.paymentCardNumber;
      const ibanPrefix = values.paymentCardNumber.substring(0, 2).toUpperCase();
      object.BankAccountType = getBankAccountTypeByCountry(ibanPrefix || values.invoiceCountry || values.country);
    }
    if (!!values.marketingCode) {
      object.ClassificationID = values.marketingCode;
      object.DefaultSelCode = values.marketingCode;
    }
    // Only add the ContactEmail if it was filled in
    if (!!values.invoiceEmail) {
      object.ContactEmail = values.invoiceEmail;
    }

    if (values.customerAddress !== values.customerBillingAddress) {
      object.InvoiceAddress =
        values.invoiceStreet +
        " " +
        values.invoiceHouseNumber +
        (values.invoiceHouseNumberAddition ? " " + values.invoiceHouseNumberAddition : "");
      object.InvoiceAddressPostCode = values.invoiceZipCode;
      object.InvoiceCity = values.invoiceCity;
      object.InvoiceCountry = values.invoiceCountry || values.country;
    }

    const config = {
      headers: { Authorization: token },
    };

    axios
      .post(urls.createExactAccount, object, config)
      .then((result) => {
        resolve(result);
      })
      .catch((err) => {
        reject(err); // Geef hele error door, niet alleen message string
      });
  });
};

export const getAllExactCustomers = (token) => {
  return new Promise((resolve, reject) => {
    const config = {
      headers: { Authorization: token },
    };
    axios
      .get(urls.getAllExactAccounts, config)
      .then((result) => {
        resolve(result.data);
      })
      .catch((err) => reject(err));
  });
};

// export const getExactOrders48h = (token) => {
//   return new Promise((resolve, reject) => {
//     const config = {
//       headers: { Authorization: token },
//     };
//     axios
//       .get(urls.getExactOrders48h, config)
//       .then((result) => {
//         resolve(result.data);
//       })
//       .catch((err) => reject(err));
//   });
// };

// export const getSnelstartOrdersDateRange = (token, dateRange) => {
//   return new Promise((resolve, reject) => {
//     const config = {
//       headers: { Authorization: token },
//     };
//     axios
//       .post(urls.getSnelstartOrdersDateRange, dateRange, config)
//       .then((result) => {
//         resolve(result.data);
//       })
//       .catch((err) => reject(err));
//   });
// };

export const getAllExactProducts = (token) => {
  return new Promise((resolve, reject) => {
    const config = {
      headers: { Authorization: token },
    };
    axios
      .get(urls.getAllExactProducts, config)
      .then((result) => {
        resolve(result.data);
      })
      .catch((err) => reject(err));
  });
};

export const updateExactAccount = (values, token) => {
  return new Promise((resolve, reject) => {
    const config = {
      headers: { Authorization: token },
    };

    axios
      .put(urls.updateExactAccount, values, config)
      .then((result) => {
        resolve(result);
      })
      .catch((err) => reject(err));
  });
};

export const sendOrderToExactInvoice = (order, token) => {
  return new Promise(function (resolve, reject) {
    const config = {
      headers: { Authorization: token },
    };

    axios
      .post(urls.exactInvoice, order, config)
      .then((response) => {
        if (response.status === 201) {
          resolve(response.data);
        } else {
          reject(response.data);
        }
      })
      .catch((error) => {
        console.error("Error creating invoice:", error.response);
        reject(error.response?.data?.message || error.message);
      });
  });
};

export const getExactInvoiceById = (invoiceId, token) => {
  return new Promise((resolve, reject) => {
    const config = {
      headers: { Authorization: token },
    };

    axios
      .get(`${urls.getExactInvoice}/${invoiceId}`, config)
      .then((result) => {
        resolve(result.data);
      })
      .catch((err) => reject(err));
  });
};

export const updateExactInvoiceCredit = (creditData, token, isAddingNewLines = true) => {
  return new Promise((resolve, reject) => {
    const config = {
      headers: { Authorization: token },
    };

    const endpoint = isAddingNewLines ? urls.exactInvoiceAddLine : urls.exactInvoice;
    const method = isAddingNewLines ? "post" : "put";

    axios[method](endpoint, creditData, config)
      .then((response) => {
        // Accept any 2xx status code as success
        if (response.status >= 200 && response.status < 300) {
          resolve(response.data);
        } else {
          reject(response.data);
        }
      })
      .catch((error) => {
        console.error(
          `Error ${isAddingNewLines ? "adding lines to" : "updating"} credit invoice in Exact:`,
          error.response,
        );
        reject(error.response?.data?.message || error.message);
      });
  });
};

export const getExactInvoiceHistory = (invoiceId, token) => {
  return new Promise((resolve, reject) => {
    const config = {
      headers: { Authorization: token },
    };

    axios
      .get(`${urls.getExactInvoiceHistory}/${invoiceId}`, config)
      .then((result) => {
        resolve(result.data);
      })
      .catch((err) => reject(err));
  });
};
